const badgeByStatus = s => {
	const map = {
		active: 'bg-emerald-100 text-emerald-800',
		expired: 'bg-gray-200 text-gray-700',
		suspended: 'bg-yellow-100 text-yellow-800',
		cancelled: 'bg-red-100 text-red-800',
	}
	return map[(s || '').toLowerCase()] || 'bg-gray-100 text-gray-800'
}

// Format date as YYYY-MM-DD; returns "—" for invalid
const formatYMD = v => {
	if (!v) return '—'
	const d = new Date(v)
	if (Number.isNaN(d.getTime())) return '—'
	const pad = n => String(n).padStart(2, '0')
	return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

const initialsFromName = (name = '') =>
	name
		.split(' ')
		.filter(Boolean)
		.map(x => x[0]?.toUpperCase())
		.slice(0, 2)
		.join('') || '??'

export default function MembershipInfoCard({ membership, onEdit, onDelete, deleting = false }) {
	const m = membership || {}

	return (
		<div className="flex h-full max-h-[550px] w-full flex-col rounded-xl border border-gray-200 bg-white shadow-sm">
			<div className="border-b border-gray-200 p-6">
				<h2 className="text-lg font-semibold text-gray-900">Membership information</h2>
			</div>

			<div className="flex-1 space-y-6 overflow-y-auto p-6">
				{/* Avatar + name */}
				<div className="flex items-center space-x-4">
					<div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-indigo-400 to-indigo-600">
						<span className="text-lg font-semibold text-white">{initialsFromName(m.customerName)}</span>
					</div>
					<div>
						<h3 className="font-semibold text-gray-900">{m.customerName || '—'}</h3>
						<p className="text-xs text-gray-500">Membership</p>
					</div>
				</div>

				{/* Fields */}
				<div className="space-y-4">
					<div className="flex items-center justify-between">
						<span className="text-sm text-gray-600">Type</span>
						<span className="text-sm font-medium text-gray-900 capitalize">{m.type || '—'}</span>
					</div>

					<div className="flex items-center justify-between">
						<span className="text-sm text-gray-600">Status</span>
						<span
							className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${badgeByStatus(
								m.status
							)}`}>
							{m.status || '—'}
						</span>
					</div>

					<div className="flex items-center justify-between">
						<span className="text-sm text-gray-600">Remaining usage</span>
						<span className="text-sm font-medium text-gray-900">{m.remainingUsage ?? '—'}</span>
					</div>

					<div className="flex items-center justify-between">
						<span className="text-sm text-gray-600">Expiry</span>
						<span className="text-sm font-medium text-gray-900">{formatYMD(m.expiryDate)}</span>
					</div>

					<div className="h-px bg-gray-200 my-2" />
				</div>

				{/* Actions */}
				<div className="space-y-3">
					<button
						onClick={onEdit}
						className="w-full rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-indigo-700">
						Edit membership
					</button>

					<button
						type="button"
						onClick={onDelete}
						disabled={deleting}
						className={`w-full rounded-lg px-4 py-2.5 text-sm font-medium shadow-sm ${
							deleting ? 'bg-gray-400 text-white cursor-not-allowed' : 'bg-red-600 text-white hover:bg-red-700'
						}`}>
						{deleting ? 'Deleting…' : 'Delete'}
					</button>
				</div>
			</div>
		</div>
	)
}
